<div class="checklist-navigation-sheet">
  <div class="sheet-header">
    <div class="header-content">
      <mat-icon style="margin-right: 0.5em;">list</mat-icon>
      <h2>Velg sjekkliste</h2>
      <span class="header-count">({{ currentIndex + 1 }} av {{ checklistList.length }})</span>
    </div>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="sheet-content">
    <p-table
      [value]="checklistList"
      pTableScrollRestore="checklist-navigation-sheet"
      [pTableScrollData]="checklistList"
      [(selection)]="selectedChecklist"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
      [scrollable]="true"
      scrollHeight="65vh"
      styleClass="p-datatable-striped p-datatable-sm"
      [paginator]="checklistList.length > 10"
      [rows]="10"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} / {totalRecords}"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="index" style="width: 40px;">
            <p-sortIcon field="index"></p-sortIcon>
          </th>
          <th pSortableColumn="objectType" style="width: 150px;">
            Type
            <p-sortIcon field="objectType"></p-sortIcon>
          </th>
          <th pSortableColumn="status" style="width: 150px;">
            Status
            <p-sortIcon field="status"></p-sortIcon>
          </th>
          <th pSortableColumn="name">
            Navn
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="tfmTag" style="width: 150px;">
            TFM Tag
            <p-sortIcon field="tfmTag"></p-sortIcon>
          </th>
          <th pSortableColumn="rdsTag" style="width: 150px;">
            RDS Tag
            <p-sortIcon field="rdsTag"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-checklist let-rowIndex="rowIndex">
        <tr [pSelectableRow]="checklist" [ngClass]="{'current-row': rowIndex === currentIndex}" [attr.data-row-id]="checklist.id">
          <td style="text-align: end;">
            <div style="display: flex; align-items: center; gap: 0.2em; justify-content: flex-end;">
              <mat-icon *ngIf="rowIndex === currentIndex" style="color: #4CAF50; font-size: 20px;">arrow_right
              </mat-icon>
              <span style="font-family: monospace; color: #bbb;">
              {{ checklist.index + 1 }}
            </span>
            </div>
          </td>
          <td>
            <div style="display: flex; align-items: center; gap: 0.5em;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #888;">
                {{ checklist.objectType ? 'folder' : 'description' }}
              </mat-icon>
              <span style="font-size: 0.9em;">{{ checklist.objectType || '-' }}</span>
            </div>
          </td>
          <td>
            <div style="display: flex; align-items: center; gap: 0.5em;">
              <p-tag [value]="checklist.status" [severity]="checklist.severity"></p-tag>
            </div>
          </td>
          <td>
            <span style="font-weight: 500;">{{ checklist.name }}</span>
          </td>
          <td>
            <span *ngIf="checklist.tfmTag" style="font-family: monospace; color: #bbb;">{{ checklist.tfmTag }}</span>
            <span *ngIf="!checklist.tfmTag" style="color: #666;">-</span>
          </td>
          <td>
            <span *ngIf="checklist.rdsTag" style="font-family: monospace; color: #bbb;">{{ checklist.rdsTag }}</span>
            <span *ngIf="!checklist.rdsTag" style="color: #666;">-</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" style="text-align: center; padding: 2em; color: #888;">
            Ingen sjekklister funnet
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

